<template>
  <div class="ring-group-icon-container">
    <el-tooltip
        v-if="tooltip"
        placement="top"
        effect="dark"
        :content="type === 'team' ? CONNECTED_INBOX_NAME : PERSONAL_INBOX_NAME"
    >
        <img v-bind="imgProps" />
    </el-tooltip>
    <img v-else v-bind="imgProps" />
  </div>
</template>

<script>
import { CONNECTED_INBOX_NAME, PERSONAL_INBOX_NAME } from '../../../constants/teaminbox';

export default {
    name: 'personal-ring-group-icon',

    props: {
        size: {
            type: Number,
            default: 46
        },

        type: {
            type: String,
            default: 'team',
            validator: (value) => {
                return ['team', 'personal'].includes(value)
            }
        },

        tooltip: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            CONNECTED_INBOX_NAME,
            PERSONAL_INBOX_NAME
        }
    },

    computed: {
        iconName () {
            return this.type === 'team'
                ? 'team-ring-group-icon'
                : 'personal-ring-group-icon'
        },

        imgProps () {
            return {
                alt: 'Inbox Icon',
                style: { width: `${this.size}px` },
                src: `/assets/images/app-icons/${this.iconName}.svg`
            }
        }
    }
}
</script>

<style>
.ring-group-icon-container {
    display: inline;
}
</style>
